import {
    apiRequest,
    polaKerjaDetail,
    polaKerjaUpdate,
    flexytimeList,
    presensiLocationList
} from "../../../../../services/adapters/kepegawaian/polaKerjaService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", polaKerjaDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", polaKerjaUpdate, {
            body: query
        }, true)
    }

    fetchFlexytime = async (query) => {
        return await apiRequest("get", flexytimeList, {
            params: query
        }, true)
    }

    fetchLocation = async (query) => {
        return await apiRequest("get", presensiLocationList, {
            params: query
        }, true)
    }
}

export default UpdateRepository